import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { FlinksType } from '@/modules/financialgateway/constants/FlinksType';
import { FlinksTokenErrorCode } from '@/modules/financialgateway/constants/FlinksTokenErrorCode';
import { TokenErrorCode } from '@/modules/financialgateway/constants/TokenErrorCode';

export class FinancialGatewayToken extends BaseModel {
  id?: number;

  expired?: boolean;

  errorCode?: string;

  flinksType?: FlinksTokenErrorCode;

  constructor(model: Partial<FinancialGatewayToken> = {}) {
    super();

    this.id = model.id;
    this.expired = model.expired;
    this.errorCode = model.errorCode;
    this.flinksType = model.flinksType;
  }

  /**
   * @param {boolean} value
   */
  setExpired(value: boolean): void {
    this.expired = value;
  }

  get isInvestment(): boolean {
    return this.flinksType === FlinksType.INVESTMENT.key;
  }

  get isBanking(): boolean {
    return this.flinksType === FlinksType.BANKING.key;
  }

  get isExpiredErrorCode(): boolean {
    return this.errorCode === FlinksTokenErrorCode.SESSION_EXPIRED;
  }

  get isRetryLaterCode(): boolean {
    return this.errorCode === FlinksTokenErrorCode.RETRY_LATER;
  }

  get isUnauthorizedErrorCode(): boolean {
    if (!this.errorCode) {
      return false;
    }

    return FlinksTokenErrorCode.unauthorizedErrorCodes()
      .concat(TokenErrorCode.getReconnectErrorCodes())
      .includes(this.errorCode);
  }
}
